import "./Banner.css";
import logo from "../../assets/logo.jpg";
import { Link } from "react-router-dom";

export const Banner = () => {
    return (
        <div className="banner-container">
            <div className="banner-subcontainer">
                <Link className="banner-button" to="/about">
                    About
                </Link>
                <Link className="banner-button" to="/services">
                    Services
                </Link>
            </div>
            <Link to="/" style={{ display: "contents" }}>
                <img
                    className="banner-logo"
                    src={logo}
                    alt="Audio Reunited logo"
                />
            </Link>
            <div className="banner-subcontainer">
                <Link className="banner-button" to="/faq">
                    FAQ
                </Link>
                <Link className="banner-button" to="/contact">
                    Contact
                </Link>
            </div>
        </div>
    );
};
